import Api from '../../@crema/services/ApiConfig';
import {Dispatch} from 'redux';
import {AppActions} from '../../types';
import {
  ADD_CART_ITEM,
  GET_CUSTOMERS,
  GET_ECOMMERCE_LIST,
  SET_ECOMMERCE_LIST,
  GET_RECENT_ORDER,
  REMOVE_CART_ITEM,
  SET_FILTER_DATA,
  SET_PRODUCT_DATA,
  SET_PRODUCT_VIEW_TYPE,
  UPDATE_CART_ITEM,
  GET_MENU_ITEM,
  NEW_CSO_ORDER,
  SET_ORDER_DATA,
  SET_NEW_ORDER,
  GET_CINEMA_LIST,
  GET_PHONE_PREFIX,
  GET_ORDER_HISTORY,
  CONFIRM_CSO_ORDER_STATUS,
  GET_WEBSITE_STATUS,
  GET_REGION_LIST,
  CLEAR_CART_ITEM,
  GET_CONFIRM_ORDER_STATUS
} from '../../types/actions/Ecommerce.action';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {
  CartItems,
  FilterData,
  ProductData,
  RecentOrders,
} from '../../types/models/ecommerce/EcommerceApp';
import {VIEW_TYPE} from '../reducers/Ecommerce';
import axios from 'axios';
import moment from 'moment'; // to get Current Date Time
import {apiBaseUrl, phase} from '../../shared/constants/AppConst';

export const onGetEcommerceData = (filterData: FilterData) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    Api.get('/api/ecommerce/list', {
      params: {filterData},
    })
      .then(data => {
        if (data.status === 200) {
          //dispatch(fetchSuccess());
          dispatch({type: GET_ECOMMERCE_LIST, payload: data.data});
          dispatch(fetchSuccess());
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.message));
      });
  };
};

//added by apple
export const setEcommerceData = (data: ProductData) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({type: SET_ECOMMERCE_LIST, payload: data});
  };
};

export const getProductDetail = (id: number | string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    Api.get('/api/ecommerce/get', {
      params: {id: id},
    })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({type: SET_PRODUCT_DATA, payload: data.data});
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getCustomers = (search: string, page: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    Api.get('/api/ecommerce/customers', {
      params: {search, page},
    })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({type: GET_CUSTOMERS, payload: data.data});
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getCartItems = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    //   Api.get('/api/cart/get')
    //     .then((data) => {
    //       if (data.status === 200) {
    dispatch(fetchSuccess());
    //         dispatch({type: SET_CART_ITEMS, payload: data.data});
    //       } else {
    //         dispatch({
    //           type: FETCH_ERROR,
    //           payload: 'Something went wrong, Please try again!',
    //         });
    //       }
    //     })
    //     .catch((error) => {
    //         dispatch(fetchError(error.message));
    //     });
  };
};

export const setViewType = (viewType: VIEW_TYPE) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({type: SET_PRODUCT_VIEW_TYPE, payload: viewType});
  };
};

export const removeCartItem = (data: CartItems) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({type: REMOVE_CART_ITEM, payload: data});
  };
};

export const clearCartItem = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    dispatch({type: CLEAR_CART_ITEM, payload: null});
    dispatch(fetchSuccess());
  };
};

export const updateCartItem = (data: CartItems) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({type: UPDATE_CART_ITEM, payload: data});
  };
};

export const addItemToCart = (data: ProductData, counter:number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({type: ADD_CART_ITEM, payload: {data,counter} });
  };
};

export const setCurrentProduct = (product: ProductData) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({type: SET_PRODUCT_DATA, payload: product});
  };
};

export const setFilters = (filters: any) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({type: SET_FILTER_DATA, payload: filters});
  };
};

//Redux Thunk added by Apple
const API_URL = apiBaseUrl+'EasiCinemaSelfOrderWs/Service.asmx/GetCSOProductListByLocation';
//const outletCode = localStorage.getItem('GSC_locid');
const operationDate = moment(new Date()).format('YYYY-MM-DD'); // get current date
const vkey = '4A117D2870914C36B600357A7519B5AC';
//const outletCode = '268';
//const operationDate = '2021-09-14';

export const onGetMenuItem = (type:any, outletCode: string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    // axios.get('https://stagingheadoffice.gsc.com.my/selforderws-dev/api/product/retrieveProductDetailsByCategory?type='+type.toLowerCase())
    axios.get(`${API_URL}?outletCode=${outletCode}&operationDate=${operationDate}&vkey=${vkey}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());   
          dispatch({
            type: GET_MENU_ITEM, 
            payload: data.data,
          });
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.message));
      });
  };
};

//Getter and Setter for OrderDetails
// export const getRecentOrders = () => {
//   return (dispatch: Dispatch<AppActions>) => {
//     let data:any = JSON.parse(localStorage.getItem('lastOrder') || '{}');
//     dispatch({type: GET_RECENT_ORDER, payload: data});
//   };
// };

//getRecentOrders by API
// export const getRecentOrders = () => {
//   return (dispatch: Dispatch<AppActions>) => {
//     dispatch(fetchStart());
//     Api.get('/api/ecommerce/orders', { })
//     //axios.post('https://stagingheadoffice.gsc.com.my/EasiCinemaSelfOrderWs/Service.asmx/ConfirmCSOOrderByLocation')
//       .then(data => {
//         if (data.status === 200) {
//           dispatch(fetchSuccess());
//           dispatch({type: GET_RECENT_ORDER, payload: data.data });
//         } else {
//           dispatch(fetchError('Something went wrong, Please try again!'));
//         }
//       })
//       .catch(error => {
//         dispatch(fetchError(error.message));
//       });
//   };
// };

//getRecentOrders from LocalStorage
export const getRecentOrders = () => {
  return (dispatch: Dispatch<AppActions>) => {
    let data:RecentOrders[] = JSON.parse(localStorage.getItem(phase+'_GSC_OrderList') ||'[]');
    let tempdata:RecentOrders[] = data; 
    //If localStorage got Pending status, get data from DB(API), else show LocalStorage Data
    if(tempdata.some(item => item.Payment.PymtStatus === 'P') || tempdata.length === 0)
    {
      axios.post(apiBaseUrl+'/EasiCinemaSelfOrderWs/Service.asmx/GetCSOOrderHistoryByPhoneNickname', formGetCSOOrderHistoryByPhoneNicknameJSON())
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_ORDER_HISTORY, 
            payload: data.data,
          });   
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchSuccess());
        dispatch(fetchError(error.message));
      });
    }
    else
    {
      dispatch({type: GET_RECENT_ORDER, payload: data});
    }
  };
};

//clear LocalStorage outdated orders
export const clearOutdatedOrders = () => {
  return (dispatch: Dispatch<AppActions>) => {
    let list:RecentOrders[] = JSON.parse(localStorage.getItem(phase+'_GSC_OrderList') ||'[]');
    //list = list.filter(data => data.Transaction.TrxnDateTime.match(moment(new Date()).format('YYYY-MM-DD')))
    list = list.slice(0,30);

    localStorage.setItem(phase+'_GSC_OrderList', JSON.stringify(list));
    //dispatch({type: GET_RECENT_ORDER, payload: data});
    dispatch(fetchSuccess())
  };
};

//once confirm order, confirmCSOOrders by API
// export const confirmCSOOrders = (data: CartItems[], hall:string, showtime:any, outletCode:string, redirectToOrder: any) => {
//   return async (dispatch: Dispatch<AppActions>) => {
//     dispatch(fetchStart());
//     axios.post(apiBaseUrl+'EasiCinemaSelfOrderWs/Service.asmx/ConfirmCSOOrderByLocation', formConfirmCSOOrdersJSON(data, hall, showtime, outletCode))
//     .then(res => {
//       console.log(res);  
//         if (res.status === 200) {
//           dispatch(fetchSuccess());
//           setOrderList(dispatch, res);
//           redirectToOrder();
//         }
//       })
//       .catch(error => {
//         dispatch(fetchSuccess());
//         //console.log('in catch:'+error.message);
//         const order :RecentOrders = formOrderStatusFail(error);
//         dispatch({type: SET_NEW_ORDER, payload:order});
//         redirectToOrder();
//       }) 
//   };
// };

//once confirm order, confirmCSOOrders by API Phase 2
export const confirmCSOOrders = (data: CartItems[], hall:string, showtime:any, outletCode:string, setSubmitting:any, redirectToPayment:any, redirectToMenuList: any) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    await axios.post(apiBaseUrl+'EasiCinemaSelfOrderWs/Service.asmx/ConfirmCSOOrderByLocationV2', formConfirmCSOOrdersJSON(data, hall, showtime, outletCode))
    .then(res => {
        if (res.status === 200) {
          setOrderStatus(dispatch, res, setSubmitting, redirectToPayment, redirectToMenuList);
          dispatch(fetchSuccess());
          //redirectToPayment();
        }
      })
      .catch(error => {
        dispatch(fetchSuccess());
        //console.log('in catch:'+error.message);
        const order :RecentOrders = formOrderStatusFail(error);
        dispatch({type: SET_NEW_ORDER, payload:order});
        //redirectToPayment();
      }) 
  };
};

//Assign params into JSON for POST API ConfirmCSOOrderByLocation
const formConfirmCSOOrdersJSON = (data: CartItems[], hall:string, showtime:string, outletCode:string) => {
  let tmpCartItem: {'ProdCode': string; 'ProdName': string; 'ProdQty': number; 'ProdUPrc': number; 'ProdPrice': number;};
  let tmpCartItems: {'ProdCode': string; 'ProdName': string; 'ProdQty': number; 'ProdUPrc': number; 'ProdPrice': number;}[] = [];
  let tmpTotal: number = 0;

  let phoneNo: string = ('+'+localStorage.getItem(phase+'_GSC_countryCode') || '')+(localStorage.getItem(phase+'_GSC_mobileNo') || '');

  for(let count = 0; count < data.length; count ++)
  {
    tmpCartItem = 
    {
      'ProdCode': data[count].ProductCode,
      'ProdName': data[count].Description,
      'ProdQty': data[count].count,
      'ProdUPrc': data[count].SalesAmount,
      'ProdPrice': parseFloat((data[count].count * data[count].SalesAmount).toFixed(2)),
    };

    tmpCartItems = tmpCartItems.concat(tmpCartItem);
    tmpTotal = tmpTotal + (data[count].count * data[count].SalesAmount);
  }
  
//let ISOshowtime = (showtime.toString() === ''? moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ') : showtime.toString());

  //Format the JSON
  const json = JSON.stringify
  ({ 'Request':{
      'Header':{
        'Ver':'1.0.0.1',
        'ReqDt':moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), // current date time
        'Req':'ConfirmCSOOrderByLocationV2',
        'Channel':'CSO',
      },
      'Body':{
        'Transaction':{
          'TrxnOutletId': outletCode,
          'TrxnDateTime':moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), // current date time
          'HallNo': hall, 
          'ShowTime':(showtime === ''? moment(new Date()).format('YYYY-MM-DD HH:mm:ss') : showtime),
          'PhoneNo': phoneNo === null? '': phoneNo,
          'Nickname':localStorage.getItem(phase+'_GSC_nickname') === null? '':localStorage.getItem(phase+'_GSC_nickname'),

        },
        'Total':{
          'TrxnAmt':parseFloat(tmpTotal.toFixed(2)),
        },
        'Payment':{
          'PymntCode':'',
          'PymtDesc':'',
          'PymntAmt':parseFloat(tmpTotal.toFixed(2)),
        },
        'Detail': tmpCartItems
      }
     } 
  });

  //DEBUG: record json pass to BE API in localhost to check the design
  console.log('formConfirmCSOOrdersJSON: '+ json);

  return json;
}

export const setCurrentOrder = (order: RecentOrders) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch({type: SET_ORDER_DATA, payload: order});
  };
};

export const resetNewOrder = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    dispatch({type: SET_NEW_ORDER, payload: null});
    dispatch(fetchSuccess());
  };
};

const formOrderStatusFail = (error: any) => {
  //PreDefine status fail
  const order: RecentOrders = 
  { 
    Status:
    {
      RespStatus:'Error',
      RespDesc:error.message,
      RespDateTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    },
    Transaction:
    {
      TrxnOutletId: '',
      TrxnNo: '',
      TrxnDateTime: '',
      HallNo: '',
      ShowTime: '',
      PhoneNo: '',
      Nickname: '',
    },
    Detail: [],
    Total:
    {
      TrxnAmt: 0,
    },
    Payment:
    {
      PymtCode: '',
      PymtDesc: '',
      PymtAmt: 0,
      PymtStatus: '',
      PymtStatusDesc: '',
      PymtDiscount: 0,
    },
      QRCode:'',
    };
  
  return order;
};

export const setOrderList = async (dispatch: Dispatch<AppActions>, res:any) => {
  //return (dispatch: Dispatch<AppActions>) => {
    try {
      dispatch(fetchSuccess());
      dispatch({type: SET_NEW_ORDER, payload: null});
      dispatch({
        type: NEW_CSO_ORDER, 
        payload: res.data, 
      });
    } catch (err) {
      dispatch(fetchSuccess());
    }
  //};
}

//Phase 2 
export const setOrderStatus= async (dispatch: Dispatch<AppActions>, res:any, setSubmitting:any, redirectToPayment:any, redirectToMenuList:any) => {
    try {
      dispatch(fetchSuccess());
      dispatch({
        type: CONFIRM_CSO_ORDER_STATUS, 
        payload:
        { 
          data: res.data, 
          setSubmitting: setSubmitting,
          redirectToPayment: redirectToPayment,
          redirectToMenuList: redirectToMenuList,
        }
      });
    } catch (err) {
      dispatch(fetchSuccess());
    }
}

//getRegionList from API
export const getRegionList = () => {
  return (dispatch: Dispatch<AppActions>) => {
    axios.get(apiBaseUrl+'/EasiCinemaSelfOrderWs/Service.asmx/GetAllMasterRegion')
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_REGION_LIST, 
            payload: data.data,
          });   
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.message));
      });
  };
};

//getCinemaList from API
export const getCinemaList = () => {
  return (dispatch: Dispatch<AppActions>) => {
    axios.get(apiBaseUrl+'/EasiCinemaSelfOrderWs/Service.asmx/GetCSOAllLocation')
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_CINEMA_LIST, 
            payload: data.data,
          });   
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.message));
      });
  };
};

//getCountryPhonePrefix from API
export const getCountryPhonePrefix = () => {
  return (dispatch: Dispatch<AppActions>) => {
    axios.get(apiBaseUrl+'/EasiCinemaSelfOrderWs/Service.asmx/GetCountryPhonePrefix')
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_PHONE_PREFIX, 
            payload: data.data,
          });   
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.message));
      });
  };
};

//getCSOOrderHistoryByPhoneNickname from API
export const getCSOOrderHistoryByPhoneNickname = () => {
  return (dispatch: Dispatch<AppActions>) => {
    axios.post(apiBaseUrl+'/EasiCinemaSelfOrderWs/Service.asmx/GetCSOOrderHistoryByPhoneNickname', formGetCSOOrderHistoryByPhoneNicknameJSON())
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_ORDER_HISTORY, 
            payload: data.data,
          });   
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchSuccess());
        dispatch(fetchError(error.message));
      });
  };
};

//Assign params into JSON for POST API getCSOOrderHistoryByPhoneNickname
const formGetCSOOrderHistoryByPhoneNicknameJSON = () => {

  let phoneNo: string = ('+'+localStorage.getItem(phase+'_GSC_countryCode') || '')+(localStorage.getItem(phase+'_GSC_mobileNo') || '');

  //Format the JSON
  const json = JSON.stringify
  ({ 'Request':{
      'Header':{
        'Ver':'1.0.0.1',
        'ReqDt':moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), // current date time
        'Req':'CheckCSOOrderHistoryByLocation',
        'Channel':'CSO',
      },
      'Body':{
        'PhoneNo': phoneNo === null? '': phoneNo,
        'Nickname':localStorage.getItem(phase+'_GSC_nickname') === null? '':localStorage.getItem(phase+'_GSC_nickname'),
      }
     } 
  });

  //DEBUG: record json pass to BE API in localhost to check the design
  console.log('formGetCSOOrderHistoryByPhoneNicknameJSON: '+ json);

  return json;
}

//checkCSOOrderHistoryByLocation from API
export const checkCSOOrderHistoryByLocation = () => {
  return (dispatch: Dispatch<AppActions>) => {
    axios.post(apiBaseUrl+'/EasiCinemaSelfOrderWs/Service.asmx/CheckCSOOrderHistoryByLocation', formCheckCSOOrderHistoryByLocationJSON())
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({
            type: NEW_CSO_ORDER, 
            payload: data.data,
          });   
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchSuccess());
        dispatch(fetchError(error.message));
      });
  };
};

//Assign params into JSON for POST API getCSOOrderHistoryByPhoneNickname
const formCheckCSOOrderHistoryByLocationJSON = () => {
  let phoneNo: string = ('+'+localStorage.getItem(phase+'_GSC_countryCode') || '')+(localStorage.getItem(phase+'_GSC_mobileNo') || '');
  let idlist: {TrxnNo:string}[] = [];
  idlist = JSON.parse(localStorage.getItem(phase+'_GSC_PendingOrder') || '') || [];
   
  //Format the JSON
  const json = JSON.stringify
  ({ 'Request':{
      'Header':{
        'Ver':'1.0.0.1',
        'ReqDt':moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), // current date time
        'Req':'CheckCSOOrderHistoryByLocation',
        'Channel':'CSO',
      },
      'Body':{
        'PhoneNo': phoneNo === null? '': phoneNo,
        'Nickname':localStorage.getItem(phase+'_GSC_nickname') === null? '':localStorage.getItem(phase+'_GSC_nickname'),
        'TrxnOutletId': localStorage.getItem(phase+'_GSC_locid'),
        'IdList': idlist, //Array List
      }
     } 
  });

  //DEBUG: record json pass to BE API in localhost to check the design
  console.log('formGetCSOOrderHistoryByPhoneNicknameJSON: '+ json);

  return json;
}

//getWebsiteStatus from API
export const getWebsiteStatus = () => {
  return (dispatch: Dispatch<AppActions>) => {
    axios.get(apiBaseUrl+'/EasiCinemaSelfOrderWs/Service.asmx/GetCSOServiceStatus')
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({
            type: GET_WEBSITE_STATUS, 
            payload: data.data,
          });   
        } else {
          dispatch(fetchError('Something went wrong, Please try again!'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getOrderStatus = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    dispatch({type: GET_CONFIRM_ORDER_STATUS, payload: null});
    dispatch(fetchSuccess());
  };
};

export const updatePaymentStatus = (booking: string, status: string, statusDesc: string) => {
  return (dispatch: Dispatch<AppActions>) => {
    axios.post(apiBaseUrl+'/EasiCinemaSelfOrderWs/Service.asmx/UpdatePaymentStatus', formUpdatePaymentStatusJSON(booking,status,statusDesc))
    .then(data => {
      if (data.status === 200) {
        dispatch(fetchSuccess());
      } else {
        dispatch(fetchError('Something went wrong, Please try again!'));
      }
    })
    .catch(error => {
      dispatch(fetchSuccess());
      dispatch(fetchError(error.message));
    });
  };
}

//Assign params into JSON for POST API UpdatePaymentStatus
const formUpdatePaymentStatusJSON = (bookingid: string, status: string, statusDesc: string) => {
   
  //Format the JSON
  const json = JSON.stringify
  ({ 'Request':{
      'Header':{
        'Ver':'1.0.0.1',
        'ReqDt':moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), // current date time
        'Req':'UpdatePaymentStatus',
        'Channel':'CSO',
      },
      'Body':{
        'TrxnOutletId': localStorage.getItem(phase+'_GSC_locid'),
        'TrxnNo': bookingid, //booking id
        'PaymentStatus': status,
        'PaymentStatusDesc': statusDesc,
      }
     } 
  });

  //DEBUG: record json pass to BE API in localhost to check the design
  console.log('formUpdatePaymentStatusJSON: '+ json);

  return json;
}
